var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrap",style:({backgroundColor: _vm.bgcolor})},[_c('div',{staticClass:"content-inner"},[_c('div',{staticClass:"md-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }